import React from 'react';

/* «Как работает KPI» — короткая справка с примером на цифрах. Тот же
   пример, что в Excel управляющего, чтобы цифры можно было сверить. */
const KpiHelp = ({ onClose }) => (
  <div className="ui-modal" onClick={onClose}>
    <div className="ui-modal-box kpi2-modal-wide kpi2-help" onClick={e => e.stopPropagation()}>
      <div className="ui-modal-head">
        <h2>Как работает KPI</h2>
        <button className="ui-icon-btn" onClick={onClose} aria-label="Закрыть">×</button>
      </div>

      <ol className="kpi2-help-steps">
        <li>
          <strong>Цели на месяц.</strong> У каждой должности 4–7 показателей. Для каждого задан вес (насколько он
          важен) и шкала из 10 порогов: какой факт даёт 10 баллов, какой 9 и так до 1. Цели свои у каждого месяца —
          новый месяц начинается с копии прошлого.
        </li>
        <li>
          <strong>Факт.</strong> Кнопка «Загрузить из iiko» подтягивает выручку, средний чек, себестоимость, продажи,
          списания, питание персонала, остатки и инвентаризацию. Остальное — жалобы, знание меню, сервис, чек-листы,
          стоп-лист, SMM, такси — управляющий вносит сам: нажмите на ячейку «внести».
        </li>
        <li>
          <strong>Балл показателя.</strong> Факт сравнивается со шкалой: сколько баллов, на уровне какого порога факт.
          Ниже порога «1» — всё равно 1 балл.
        </li>
        <li>
          <strong>Итоговый балл</strong> = сумма «вес × балл» по всем показателям, от 1 до 10.
        </li>
        <li>
          <strong>Премия</strong> — по шкале премии должности: от 7 баллов и выше. У официантов — процент от личной
          выручки, у остальных — фиксированная сумма.
        </li>
        <li>
          <strong>Закрыть месяц.</strong> Когда всё внесено, месяц закрывают: премии фиксируются, ведомость уходит
          бухгалтеру, а премии можно одной кнопкой передать в табель «Сотрудников».
        </li>
      </ol>

      <div className="kpi2-help-example">
        <h3>Пример: официант за месяц</h3>
        <table className="kpi2-help-table">
          <thead><tr><th>Показатель</th><th>Вес</th><th>Факт</th><th>Балл</th><th>Вес × балл</th></tr></thead>
          <tbody>
            <tr><td>Средний чек</td><td>40%</td><td>1 420 ₽</td><td>8</td><td>3,2</td></tr>
            <tr><td>Жалобы</td><td>30%</td><td>0</td><td>10</td><td>3,0</td></tr>
            <tr><td>Знание меню</td><td>20%</td><td>90%</td><td>8</td><td>1,6</td></tr>
            <tr><td>Время обслуживания</td><td>10%</td><td>22 мин</td><td>8</td><td>0,8</td></tr>
          </tbody>
          <tfoot><tr><td colSpan={4}>Итоговый балл</td><td>8,6</td></tr></tfoot>
        </table>
        <p>
          8,6 балла — ступень «от 8»: премия 0,4% от личной выручки. При выручке 400 000 ₽ — 1 600 ₽. Под карточкой
          сотрудника подсказано, что подтянуть до следующей ступени: здесь достаточно поднять средний чек до 1 450 ₽.
        </p>
      </div>

      <div className="ui-modal-actions">
        <button className="ui-btn-primary kpi2-btn-auto" onClick={onClose}>Понятно</button>
      </div>
    </div>
  </div>
);

export default KpiHelp;
